// Projects.jsx

import React, { useState, useEffect } from 'react';
import '../styles/Projects.css'; 
import Landslides from 'C:/Users/yedla/Downloads/MyPortfolio/MyPortfolio/src/images/Landslides.jpg';
import SalesDashboard from 'C:/Users/yedla/Downloads/MyPortfolio/MyPortfolio/src/images/SalesDashboard.png';
import Loansanction from 'C:/Users/yedla/Downloads/MyPortfolio/MyPortfolio/src/images/Loansanction.png';
import imageclassify from 'C:/Users/yedla/Downloads/MyPortfolio/MyPortfolio/src/images/imageclassify.jpg';
import prediction from 'C:/Users/yedla/Downloads/MyPortfolio/MyPortfolio/src/images/prediction.jpg';

const Projects = () => {
  const [slideIndex, setSlideIndex] = useState(1);
  useEffect(() => {
    showSlides(slideIndex);
  }, [slideIndex]);

  function plusSlides(n) {
    setSlideIndex(slideIndex + n);
  }

  function currentSlide(n) {
    setSlideIndex(n);
  }

  function showSlides(n) {
    let i;
    let slides = document.getElementsByClassName("mySlides");
    let dots = document.getElementsByClassName("dot");

    if (n > slides.length) {
      setSlideIndex(1);
    }

    if (n < 1) {
      setSlideIndex(slides.length);
    }

    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }

    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }

    slides[slideIndex - 1].style.display = "block";
    dots[slideIndex - 1].className += " active";
  }

  return (

    <div id="projects" className="projectSection">
    <h1 className="MainTitleProjects">Projects</h1>
    <div>
      {/* Slideshow container */}
      <div className="slideshow-container">
        {/* Full-width images with number and caption text */}
        <div className="mySlides fade">
          {/* <div className="numbertext">1 / 3</div> */}
          <img src={Landslides} style={{ width: '100%' }} />
          <div className="text"><button className="explorebtn"><a href="https://github.com/Karthikeya201202/U_NET-for-Landslides" target="_blank">U-Net Model</a></button></div>
        </div>

        <div className="mySlides fade">
          {/* <div className="numbertext">2 / 3</div> */}
          <img src={Loansanction} style={{ width:'100%'}} />
          <div className="text"><button className="explorebtn"><a href="https://github.com/Karthikeya201202/Loan_Sanction" target="_blank">Loan Sanction</a></button></div>
        </div>

        <div className="mySlides fade">
          {/* <div className="numbertext">2 / 3</div> */}
          <img src={prediction} style={{ width: '100%' }} />
          <div className="text"><button className="explorebtn"><a href="https://github.com/Karthikeya201202/Stacking_Max_Tensile" target="_blank">Tensile strength Prediction</a></button></div>
        </div>

        <div className="mySlides fade">
          {/* <div className="numbertext">2 / 3</div> */}
          <img src={SalesDashboard} style={{ width: '100%' }} />
          <div className="text"><button className="explorebtn"><a href="https://github.com/Karthikeya201202/Super-Store-Sales-Dashboard" target="_blank">Sales Dashboard</a></button></div>
        </div>

        <div className="mySlides fade">
          {/* <div className="numbertext">2 / 3</div> */}
          <img src={imageclassify} style={{ width: '100%' }} />
          <div className="text"><button className="explorebtn"><a href="https://github.com/Karthikeya201202/Unsupervised-Image-Classification" target="_blank">Unsupervised Classification</a></button></div>
        </div>


        {/* <div className="mySlides fade">
         
          <img src="https://www.w3schools.com/howto/img_snow_wide.jpg" style={{ width: '100%' }} />
          <div className="text">Caption Three</div>
        </div> */}

        {/* Next and previous buttons */}
        <a className="prev" onClick={() => plusSlides(-1)}>&#10094;</a>
        <a className="next" onClick={() => plusSlides(1)}>&#10095;</a>
      </div>
      <br />

      {/* The dots/circles */}
      <div style={{ textAlign: 'center' }}>
        <span className="dot" onClick={() => currentSlide(1)}></span>
        <span className="dot" onClick={() => currentSlide(2)}></span>
        <span className="dot" onClick={() => currentSlide(3)}></span>
        <span className="dot" onClick={() => currentSlide(4)}></span>
        <span className="dot" onClick={() => currentSlide(5)}></span>
        {/* <span className="dot" onClick={() => currentSlide(3)}></span> */}
      </div>
    </div>
    </div>
  );
};

export default Projects;
